/* eslint-disable no-useless-escape */
const onlyDigitRegex = /[0-9]/g;
const notDigitRegex = /\D/g;
const subGrupWith2DigitsRegex = /(\d{2})(\d)/;
const subGrupWith3DigitsRegex = /(\d{3})(\d)/;
const subGrupWith4DigitsRegex = /(\d{4})(\d)/;
const subGrupWith5DigitsRegex = /(\d{5})(\d)/;
const cpfRegex = /^(\d{3}\.?){3}\-?\d{2}$/;
const cnpjRegex = /^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/;
const docBrRegex = /(?:(?:\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2})|(?:\d{3}\.?\d{3}\.?\d{3}-?\d{2}))/;
const phoneBrRegex = /^(\+?55\s?)?(\([1-9]{2}\)|\d{2}\s?)(\d{4,5}){1}[\s.-]?(\d{4})$/

export const regex = {
  onlyDigitRegex,
  notDigitRegex,
  subGrupWith2DigitsRegex,
  subGrupWith3DigitsRegex,
  subGrupWith4DigitsRegex,
  subGrupWith5DigitsRegex,
  cpfRegex,
  cnpjRegex,
  docBrRegex,
  phoneBrRegex
}
